import React from 'react';
import { StepLayout, ActionButton } from "../../BusinessOnboardingWidget.utils";
import { Send1stAgreementIcon } from "../../BusinessOnboardingWidget.icons";
import styles from "./TestAgreement.module.scss";
import { useRedirectToProposal } from "../../../../../hooks/useCreateAgreement";
import { useEventReporter, useStore } from "../../../../../contexts";
export default function TestAgreement(_ref) {
  let {
    isComplete
  } = _ref;
  const {
    openCreationModal
  } = useRedirectToProposal();
  const {
    logBI
  } = useStore(store => store.actions);
  const {
    reportToGtm,
    reportToAppcues,
    reportToHeap
  } = useEventReporter();
  return /*#__PURE__*/React.createElement(StepLayout, {
    id: "testAgreement",
    title: isComplete ? 'You’ve successfully sent a test agreement!' : 'Start by sending a test agreement',
    subtitle: "Get a feel for the Anchor experience before sending it to your client. Once the test agreement is sent, you\u2019ll be able to see the approval process from your client\u2019s perspective.",
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.actionsWrapper
    }, /*#__PURE__*/React.createElement(ActionButton, {
      "data-testid": "onboarding-widget-test-agreement-btn",
      onClick: async e => {
        e.preventDefault();
        logBI(11900);
        reportToGtm('button-click', 'test-agreement-initiated');
        reportToAppcues('button-click', 'test-agreement-initiated');
        reportToHeap('testAgreement', 'click', 'test-agreement-initiated');
        await openCreationModal(undefined, {
          defaultToSampleContact: true
        });
      }
    }, isComplete ? 'Send another one' : 'Send a test agreement'))),
    icon: /*#__PURE__*/React.createElement(Send1stAgreementIcon, null)
  });
}